<template>
	<div class="crumbs">
		<div class="con-box">
			<a-breadcrumb>
			    <a-breadcrumb-item>当前位置: &nbsp;&nbsp;&nbsp;<a href="/">首页</a></a-breadcrumb-item>
			    <a-breadcrumb-item v-for="(item, index) in crumbData" :key="item.channel">
					<span v-if="index !== crumbData.length-1">
						<a :href="item.path">{{item.name}}</a>
					</span>
					<span v-if="index == crumbData.length-1">
						{{item.name}}
					</span>
				</a-breadcrumb-item>
			  </a-breadcrumb>
		</div>
	</div>
</template>

<script>
export default {
  name: 'a-crumbs',
  props: {
    crumbData: {
      type: Array,
      default: ()=> []
    }
  },
  data () {
    return {
      //crumbData: this.$store.state.crumbInfo
    }
  }
}
</script>

<style scoped>
	.crumbs {
	  height: 60px;
	  line-height: 60px;
	  .el-breadcrumb {
	    .el-breadcrumb__item {
	      line-height: 60px;
	      @include font(14px, $gray6, left, 0);
	      &:first-child i {
	        display: none;
	      }
	      .is-link {
	        font-weight: normal !important;
	      }
	      &:last-child {
	        .el-breadcrumb__inner {
	          color: $gray3;
	          font-weight: bold;
	        }
	      }
	    }
	  }
	}
</style>